import { createBrowserHistory } from 'history';

export const history = createBrowserHistory();

export const push = (path, state) => {
  history.push(path, state);
};

export const pathname = () => history.location.pathname;

export default {
  history,
  push,
  pathname
};